import { BillingAdjustmentIssueType } from '../../../../enums';

export interface IBillingSubtypeDom {
    issueType: BillingAdjustmentIssueType;
}
